export const PoliciesMocked = [];
